document.addEventListener('DOMContentLoaded', function () {
    // Function to update the visibility of variant images
    function updateVariantImages(selectedVariantId, crossSellItem) {
        const images = crossSellItem.querySelectorAll('.cross-sell-variant-image');
        images.forEach(image => {
            if (image.getAttribute('variant-id') === selectedVariantId) {
                image.classList.remove('hide');
            } else {
                image.classList.add('hide');
            }
        });
    }

    // Listener for variant selection changes
    document.querySelectorAll('.product-form__variants').forEach(select => {
        select.addEventListener('change', (e) => {
            const selectedVariantId = e.target.value;
            const crossSellItem = e.target.closest('.cross-sell__products-item');
            const variantIdInput = crossSellItem.querySelector('#variantIdInput');
            variantIdInput.value = selectedVariantId;

            // Update images based on the selected variant
            updateVariantImages(selectedVariantId, crossSellItem);
        });
    });

    // Initial variant image update based on the first selected option
    document.querySelectorAll('.product-form__variants').forEach(select => {
        const crossSellItem = select.closest('.cross-sell__products-item');
        const selectedVariantId = select.value;
        updateVariantImages(selectedVariantId, crossSellItem);
    });

    // Observer for detecting changes indicating cartDrawer opening
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.attributeName === 'class' && mutation.target.classList.contains('cartDrawer') && mutation.target.classList.contains('open')) {
                console.log('Cart Drawer opened');
                updateVariantImages(selectedVariantId, crossSellItem);
                // Perform actions when cartDrawer is opened, if needed
            }
        });
    });

    // Start observing the document body for attribute changes indicating cartDrawer opening
    observer.observe(document.body, {
        attributes: true,
        subtree: true // To observe changes in descendants
    });
});
// Listener for "Add to Bag" button clicks
document.querySelectorAll('.add-to-bag-btn').forEach(button => {
    button.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const crossSellItem = button.closest('.cross-sell__products-item');
        const variantIdInput = crossSellItem.querySelector('#variantIdInput');
        const variantSelect = crossSellItem.querySelector('.product-form__variants');

        // Check if variantIdInput is empty and update it with the first select option value if needed
        if (!variantIdInput.value) {
            variantIdInput.value = variantSelect.value;
        }

        const selectedVariantId = variantIdInput.value; // Now use the value from the hidden input

        // Call the function to add the item to the cart with the selected variant ID and quantity of 1
        add_to_cart_grid(selectedVariantId, 1);
    });
});


// Function to add an item to the cart
function add_to_cart_grid(variantId, qty) {
    // Constructing the request body
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', qty);

    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(json => {
        console.log('Success:', json);
         // Dispatch an event indicating a product has been added
        const ajaxProductAddedEvent = new CustomEvent('ajaxProduct:added', {
            detail: {
                product: json,
                quantity: qty
            }
        });
        document.dispatchEvent(ajaxProductAddedEvent);

        // Optionally, directly call CartDrawer methods if not using event listeners for opening
        if (theme.CartDrawer && theme.CartDrawer.prototype.open) {
            var cartDrawer = new theme.CartDrawer();
            cartDrawer.open(); // This assumes a CartDrawer instance can be directly utilized here
        }
      
    })
    .catch(error => {
        console.error('Error:', error);
    });
}
